// router.tsx
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router-dom";

import Home from "./containers/Home";
import Error404 from "./containers/Error404";
import Renew from "./containers/Renew";
import Reseller from "./containers/Reseller";
import Download from "./containers/Download";
import InstallSmartTv from "./containers/InstallSmart";
import InstallTvBox from "./containers/InstallTvBox";
import InstallFireStick from "./containers/InstallFireStick";
import InstallPc from "./containers/InstallPc";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<Home />} />
            <Route path="/renovar" element={<Renew />} />
            <Route path="/reseller" element={<Reseller />} />
            <Route path="/descarga" element={<Download />} />
            <Route path="/smart-tv" element={<InstallSmartTv />} />
            <Route path="/tv-box" element={<InstallTvBox />} />
            <Route path="/fire-stick" element={<InstallFireStick />} />
            <Route path="/pc-mac" element={<InstallPc />} />
            <Route path="*" element={<Error404 />} />
        </>
    ),
    {
        future: {
            v7_startTransition: true, // <--- Activamos el flag
        },
    }
);